/* file description */
import React from 'react';
import QRCode from 'qrcode.react';
import { COLUMN_FROM, VALUE_TYPES } from './consts';
import { TransformNalmalType2TableColumn } from './type';

export const transformQrCodeTableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
}) => {
  targetColumn.valueType = VALUE_TYPES.TEXT;

  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    return targerValue ? <QRCode value={targerValue} size={50} /> : '';
  };

  // 获取自定义的组件和表单Item配置
  if (field?.bizConfig?.fieldProps) {
    targetColumn.fieldProps = field?.bizConfig?.fieldProps;
  }
  if (field?.bizConfig?.formItemProps) {
    targetColumn.formItemProps = field?.bizConfig?.formItemProps;
  }
  return targetColumn;
};
